import { render } from "./PendingRequests.vue?vue&type=template&id=4fb15250"
import script from "./PendingRequests.vue?vue&type=script&lang=js"
export * from "./PendingRequests.vue?vue&type=script&lang=js"
script.render = render

export default script